import { LogIn, LogOut, PackageSearch, ShoppingCart, UserCircle } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
export default function Navbar(){
  const {user,logout}=useAuth(); const {itemCount}=useCart();
  return <header className="navbar"><div className="nav-inner">
    <Link className="brand" to="/"><span className="brand-icon"><PackageSearch size={24}/></span><span>UniLoot</span></Link>
    <nav className="nav-links"><NavLink to="/products">Produk</NavLink><NavLink to="/cart">Keranjang</NavLink>{user&&<NavLink to="/orders">Pesanan</NavLink>}</nav>
    <div className="nav-actions"><Link className="icon-button cart-button" to="/cart" aria-label="Keranjang"><ShoppingCart size={21}/>{itemCount>0&&<span>{itemCount}</span>}</Link>
      {user?<><div className="user-pill"><UserCircle size={19}/><span>{user.name}</span></div><button className="btn outline" onClick={logout}><LogOut size={18}/>Keluar</button></>:<Link className="btn primary" to="/login"><LogIn size={18}/>Masuk</Link>}
    </div>
  </div></header>;
}
